import { connect } from 'react-redux'
import { setHomePageStoriesIsLoaded } from 'redux/actions'
import HomepageStories from 'pages/dashboard/HomepageStories'

const mapDispatchToProps = dispatch => ({
  setHomePageStoriesIsLoaded: isLoaded => dispatch(setHomePageStoriesIsLoaded(isLoaded))
})

const mapStateToProps = (state) => ({
  isLogged: state.user.isLogged
})

export default connect(mapStateToProps, mapDispatchToProps)(HomepageStories)
